export function normalizeGalleryItems(entries = []) {
  return entries.map((entry) => ({
    slug: entry.slug?.da || entry.slug || entry.id,
    title: entry.titel,
    images: Array.isArray(entry.billeder) ? entry.billeder : [],
    count: Array.isArray(entry.billeder) ? entry.billeder.length : 0,
    description: entry.beskrivelse || '',
    terms: entry.terms || {},
  }));
}

export function getGalleryFilterFromEntry(entry) {
  const terms = entry?.terms?.kategori || [];
  return Array.isArray(terms) && terms.length ? terms[0] : entry?.slug?.da;
}
